<template>
  <v-row justify="end" dense>
    <v-col cols="12" sm="6" md="3" lg="1" xl="1">
      <v-text-field
        label="Total"
        readonly
        :value="totalItems"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="1" xl="1">
      <v-autocomplete
        :items="pages"
        label="Pages"
        v-model="page"
        :suffix="'/'+totalPages"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="1" xl="1">
      <v-select
        v-model="itemsPerPage"
        label="Rows"
        :items="itemsPerPageOptions"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Paginator',

    props: {
      pagination: Object,

      itemsPerPageOptions: Array,

      totalItems: Number,
    },

    data () {
      return {
        page: this.pagination.page || 1,
        itemsPerPage: this.pagination.itemsPerPage || this.itemsPerPageOptions[0]
      }
    },

    watch: {
      page () {
        this.update({page: this.page})
      },

      itemsPerPage () {
        this.update({itemsPerPage: this.itemsPerPage})
      }
    },

    computed: {
      pages () {
        if (this.itemsPerPage == null || this.totalItems == null) {
          return []
        }

        const pages = []

        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i)
        }

        return pages
      },

      totalPages () {
        if (this.itemsPerPage == null || this.totalItems == null) {
          return 0
        }

        return Math.ceil(this.totalItems / this.itemsPerPage)
      }
    },

    methods: {
      update (field) {
        this.$emit('update:pagination', {
          ...JSON.parse(JSON.stringify(this.pagination)),
          ...field
        })
      }
    },

    created () {
      if (!this.pagination.itemsPerPage) {
        this.update({itemsPerPage: this.itemsPerPage})
      }
    },
  }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Paginator.vue